import { render, staticRenderFns } from "./event-modal.vue?vue&type=template&id=4ffca4b0&scoped=true&"
import script from "./event-modal.vue?vue&type=script&lang=js&"
export * from "./event-modal.vue?vue&type=script&lang=js&"
import style0 from "./event-modal.vue?vue&type=style&index=0&id=4ffca4b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffca4b0",
  null
  
)

export default component.exports